export default __webpack_public_path__ + "static/media/frg--outdoor-cinema.72ad223a.png";